import Decimal from 'decimal.js';

import { AssetClassLiquidityStatus } from '@/types/schema';
import { PathsOf } from '@/types/subform';

export const NEW_ASSET_CATEGORY_SENTINEL = '__NEW_ASSET_CATEGORY__';

/**
 * The display name of the system-created Liabilities asset class.
 * Used to identify rows that should have special treatment (e.g., hiding growth rate and liquidity inputs).
 */
export const LIABILITY_ASSET_CLASS_NAME = 'Liabilities';

/**
 * The display name of the system-created Receivables asset class.
 * Used to identify rows that should have special treatment (e.g., hiding growth rate and liquidity inputs).
 */
export const RECEIVABLE_ASSET_CLASS_NAME = 'Receivables';

export interface AssetCategory {
  integrationCategoryIds: string[];
  _isSystemClass: boolean;
  name: string;
  liquidityStatus: AssetClassLiquidityStatus;
  growthRate: Decimal;
  taxDragRate: Decimal;
  balanceSheetCategoryID?: string;
  isRealTpp: boolean;
}

export interface AssetCategoriesForm {
  currentlyEditingRowId: string | null;
  assetCategoriesById: Record<string, AssetCategory>;
}

export type AssetCategoriesFormPaths = PathsOf<AssetCategoriesForm>;

export interface RowData {
  /** this is a special property that indicates what value to show when dragging to reorder */
  __reorder__: string;
  id: string;
  name: string;
  isSystemClass: boolean;
  /** Whether this row is the system-created "Liabilities" asset class */
  isLiabilityClass: boolean;
  /** Whether this row is the system-created "Receivables" asset class */
  isReceivableClass: boolean;

  // these others are just here to represent the fact that there are columns for each row that represent this concept.
  // because these values are editable, we read/write to them from the form state.
  integrationCategories: null;
  balanceSheetCategory: null;
  growthRate: null;
  taxDragRate: null;
  liquidity: null;
  isRealTpp: null;
  action: unknown;
}
